import { navigateTo, defineNuxtRouteMiddleware, useCookie } from '#imports';
import { UserStatus } from '@vue-util/cookie';

const handleGuestNavigation = (query, isSignedIn, navigateToFn, entryPoint) => {
  if (entryPoint === 'bcom') {
    if (query) {
      return navigateToFn({
        path: '/wishlist/mylist',
        query: { listGuid: query },
      });
    } else if (isSignedIn) {
      return navigateToFn('/wishlist/home');
    }
    return navigateToFn('/wishlist/mylist');
  }
  return navigateToFn('/wishlist/home');
};
export function handleNavigation(
  to,
  {
    navigateToFn = navigateTo,
    userStatus = UserStatus,
    entryPoint = import.meta.env.VITE_ENTRY_POINT,
    useCookieFn = useCookie,
    isClient = import.meta.client,
  } = {},
) {
  const { path, query } = to;

  let isSignedIn = false;
  if (isClient) {
    isSignedIn = userStatus.isSignedIn();
  } else {
    const signedInCookie = useCookieFn('SignedIn');
    isSignedIn = String(signedInCookie?.value) === '1';
  }
  if (path.startsWith('/wishlist/home') && !isSignedIn) {
    return navigateToFn('/wishlist/mylist');
  }

  if (path.startsWith('/wishlist/find')) {
    return navigateToFn('/wishlist/home');
  }

  if (path.startsWith('/wishlist/guest')) {
    return handleGuestNavigation(query, isSignedIn, navigateToFn, entryPoint);
  }

  return undefined;
}

export default defineNuxtRouteMiddleware((to) => handleNavigation(to));
